export const privacyPolicy = {
  title: 'Privacy policy',
  lastUpdated: '2026-04-23',
  sections: [
    {
      heading: 'Who we are',
      body: [
        'JUST SEE LTD ("we", "our", "us") is a design and development studio registered in Cyprus. This policy explains what personal data we collect, why we collect it, and how we handle it.',
        'Questions about this policy can be sent to business@justsee-ltd.com.',
      ],
    },
    {
      heading: 'What we collect',
      body: [
        'When you submit our contact form, we collect the information you enter: name, email address, optional phone number, chosen service category, optional budget range, and message.',
        'We do not use third-party analytics. We do not use tracking cookies. We do not build advertising profiles. The only cookie we set records your consent to this notice, which is required for legal compliance.',
      ],
    },
    {
      heading: 'Why we collect it',
      body: [
        'The information you enter in our contact form is used to reply to your enquiry. We do not add it to a mailing list, share it with partners, or use it for marketing.',
      ],
    },
    {
      heading: 'How long we keep it',
      body: [
        'Enquiry correspondence is kept for two years, unless you ask us to delete it sooner. After that it is removed from our email systems. Signed project contracts and invoices are kept for seven years, as required by Cyprus accounting law.',
      ],
    },
    {
      heading: 'Your rights',
      body: [
        'Under the GDPR you have the right to access, correct, export, or delete personal data we hold about you. You can also object to how we process it, or ask us to restrict processing. To exercise any of these rights, send an email to business@justsee-ltd.com and we will respond within thirty days.',
        'You also have the right to lodge a complaint with the Office of the Commissioner for Personal Data Protection in Cyprus.',
      ],
    },
    {
      heading: 'How we protect it',
      body: [
        'Your data is kept in reputable email and storage services with standard encryption in transit and at rest. Only the two directors of the studio have access. We do not store passwords or payment card details ourselves.',
      ],
    },
    {
      heading: 'Changes to this policy',
      body: [
        'If we change this policy, the date at the top will be updated. Material changes affecting how we handle your data will be announced by email to clients with active projects.',
      ],
    },
  ],
};
